import { render, staticRenderFns } from "./adminView.vue?vue&type=template&id=58784d9b&scoped=true"
import script from "./adminView.vue?vue&type=script&lang=js"
export * from "./adminView.vue?vue&type=script&lang=js"
import style0 from "./adminView.vue?vue&type=style&index=0&id=58784d9b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58784d9b",
  null
  
)

export default component.exports